export const SET_START_DATE_ANALYZER_DATE_TIME =
    'SET_START_DATE_ANALYZER_DATE_TIME'
export const SET_END_DATE_ANALYZER_DATE_TIME = 'SET_END_DATE_ANALYZER_DATE_TIME'
export const SET_PAGE_ANALYZER_MEASUREMENT = 'SET_PAGE_ANALYZER_MEASUREMENT'
export const SET_LIMIT_ANALYZER_MEASUREMENT = 'SET_LIMIT_ANALYZER_MEASUREMENT'
export const SET_SEARCH_ANALYZER_MEASUREMENT = 'SET_SEARCH_ANALYZER_MEASUREMENT'
export const SET_ORDER_ANALYZER_MEASUREMENT = 'SET_ORDER_ANALYZER_MEASUREMENT'
export const SET_CONFIG_ANALYZER_MEASUREMENT = 'SET_CONFIG_ANALYZER_MEASUREMENT'
export const SET_CONFIG_UPDATE_ANALYZER_MEASUREMENT =
    'SET_CONFIG_UPDATE_ANALYZER_MEASUREMENT'
